import { getDataFormatter, getFormatPattern, getLocale, getNumericColumnFormatPattern, isPercentColumn, } from '@thoughtspot/formatter-service';
import { getValueFormattedByConfig } from '@thoughtspot/number-format-util';
import { isEnableSummariesCustomFormatByDefault as allowFormatPattern } from '@thoughtspot/session-service';
import { convertValueFromBackend, isColumnValidForNumberFormatting, isDateColumn, isTimeColumn, } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
export const getSummariesFormatConfig = (headlineViz) => {
    var _a, _b;
    const userDefinedFormatConfig = (_b = (_a = headlineViz.vizProp) === null || _a === void 0 ? void 0 : _a.columnProperty) === null || _b === void 0 ? void 0 : _b.summariesNumberFormatConfig;
    const column = headlineViz.headlineColumn;
    if (userDefinedFormatConfig && isColumnValidForNumberFormatting(column)) {
        return userDefinedFormatConfig;
    }
    return getNumericColumnFormatPattern(column, allowFormatPattern() || isPercentColumn(column));
};
export const getFormattedValueForHeadlineColumn = (value, headlineViz, column) => {
    var _a, _b;
    const isHeadLineDateType = isDateColumn(headlineViz.headlineColumn) ||
        isTimeColumn(headlineViz.headlineColumn);
    const formatPattern = getFormatPattern(column);
    const columnLocale = getLocale(column);
    const isHeadLineDateRangeType = isHeadLineDateType &&
        ((_a = headlineViz.data) === null || _a === void 0 ? void 0 : _a.value) &&
        ((_b = headlineViz.data) === null || _b === void 0 ? void 0 : _b.value2);
    if (isHeadLineDateType) {
        const minDateEpoch = convertValueFromBackend(headlineViz.headlineColumn, headlineViz.data.value);
        const minDateValue = getDataFormatter(headlineViz.headlineColumn)(minDateEpoch, {
            noShorten: false,
            displayToCustomCalendarValueMap: {
                [minDateEpoch]: headlineViz.data.value,
            },
        });
        const maxDateEpoch = convertValueFromBackend(headlineViz.headlineColumn, headlineViz.data.value2);
        const maxDateValue = getDataFormatter(headlineViz.headlineColumn)(maxDateEpoch, {
            noShorten: false,
            displayToCustomCalendarValueMap: {
                [maxDateEpoch]: headlineViz.data.value2,
            },
        });
        return isHeadLineDateRangeType
            ? `${minDateValue} - ${maxDateValue}`
            : minDateValue;
    }
    if (_.isFinite(value)) {
        const formatConfig = getSummariesFormatConfig(headlineViz);
        return getValueFormattedByConfig(value, formatConfig, {
            formatPattern,
            columnLocale,
        });
    }
    return getDataFormatter(column)(value);
};
//# sourceMappingURL=headline-utils.js.map